import React from 'react';

import { Box, Typography } from '@mui/material';

import { Nullable } from '@clearverify/types';

import { Avatar } from 'src/components/shared/Avatar';
import { demoPrivacyBlurStyles } from 'src/constants/demoPrivacyMode';
import { useDemoPrivacyBlurred } from 'src/hooks/demoPrivacyMode';

type DemoPrivacyTextProps = {
  children: React.ReactNode;
  reveal?: boolean;
};

export const DemoPrivacyText: React.FC<DemoPrivacyTextProps> = ({ children, reveal }) => {
  const isBlurred = useDemoPrivacyBlurred(reveal);

  return (
    <Box component="span" sx={isBlurred ? demoPrivacyBlurStyles : undefined}>
      {children}
    </Box>
  );
};

type DemoPrivacyFieldValueProps = {
  value: Nullable<string>;
  reveal?: boolean;
};

export const DemoPrivacyFieldValue: React.FC<DemoPrivacyFieldValueProps> = ({ value, reveal }) => {
  const isBlurred = useDemoPrivacyBlurred(reveal);

  return (
    <Typography component="span" sx={isBlurred ? demoPrivacyBlurStyles : undefined}>
      {value || '–'}
    </Typography>
  );
};

type DemoPrivacyAvatarProps = {
  src?: Nullable<string>;
  variant?: 'circular' | 'rounded' | 'square';
  sx?: React.ComponentProps<typeof Avatar>['sx'];
};

export const DemoPrivacyAvatar: React.FC<DemoPrivacyAvatarProps> = ({ src, variant, sx }) => {
  const isBlurred = useDemoPrivacyBlurred();

  return <Avatar src={isBlurred ? null : src} variant={variant} sx={sx} />;
};
